import StaffNavBarTemplate from './StaffNavBarTemplate';

export default StaffNavBarTemplate;
